import { Icon } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

export interface IIconWithTooltipProps {
    name: string;
    icon: Icon;
    tooltipText: string;
    iconClassName?: string;
    className?: string;
}

const IconWithTooltip = ({
    name, className, icon, iconClassName, tooltipText,
}: IIconWithTooltipProps) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const toggleTooltip = () => {
        setOpenTooltip(!openTooltip);
    };

    return (
        <div className={className}>
            <NSIcon
                id={`${name}-tooltip`}
                icon={icon}
                className={iconClassName}
            />
            <Tooltip
                target={`${name}-tooltip`}
                isOpen={openTooltip}
                toggle={toggleTooltip}
                placement="top"
            >
                <div>{tooltipText}</div>
            </Tooltip>
        </div>
    );
};

export default IconWithTooltip;
